/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SetNominationChangedMutationVariables = Types.Exact<{
  cargoIds: Array<Types.Scalars['Long']['input']>;
}>;


export type SetNominationChangedMutation = {
  __typename?: 'Mutation',
  setNominationChanged?: Array<{
    __typename?: 'Cargo',
    id: number
  } | null> | null
};


export const SetNominationChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetNominationChanged"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setNominationChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cargoIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"changed"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetNominationChangedMutation, SetNominationChangedMutationVariables>;